export const visit = (vm, at) => {
at({ "en": { "interactiveCards": { "calendar": { "prevMonthAriaLabel": "Previous month", "nextMonthAriaLabel": "Next month" }, "timezonePicker": { "placeholder": "Select a timezone" } } } });
};